<bic-popup (close)="onClose()" [customClass]="'w-[560px]'" [hasBackdrop]="true" [title]="'Prüflauf duplizieren'">
  <div bicPopupContent class="flex flex-col gap-4">
    <p class="text-sm text-gray-900">
      „{{ checkName }}" stammt aus {{ ownerProjectNames }} und verwendet myChecks, die in diesem
      Projekt nicht verfügbar sind. Die Kopie gehört diesem Projekt – ausgewählte myChecks werden
      deshalb als eigene Kopien hier angelegt, nicht ausgewählte werden aus der Kopie entfernt.
    </p>

    <div class="flex max-h-[260px] flex-col gap-2 overflow-y-auto">
      @for (ruleset of rulesets; track ruleset.id) {
        <label
          class="flex flex-row items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5 {{ ruleset.shareable ? 'cursor-pointer hover:border-green' : 'cursor-not-allowed' }}">
          <input (change)="toggle(ruleset)"
                 [checked]="selected.has(ruleset.id)"
                 [disabled]="saving || !ruleset.shareable"
                 class="h-4 w-4 shrink-0 rounded border-gray-300 text-green accent-green focus:ring-green"
                 type="checkbox"/>
          <span class="flex min-w-0 flex-1 flex-col">
            <span class="truncate text-sm font-medium text-gray-900">{{ ruleset.name }}</span>
            @if (!ruleset.shareable) {
              <span class="text-xs text-red">
                Gehört {{ ruleset.ownerProjectName || 'einem anderen Projekt' }} und kann nicht mitkopiert werden –
                wird aus der Kopie entfernt
              </span>
            } @else if (!selected.has(ruleset.id)) {
              <span class="text-xs text-red">Wird aus der Kopie entfernt</span>
            }
          </span>
        </label>
      }
    </div>

    <div class="flex flex-row items-start gap-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <fa-icon [icon]="faCircleInfo" class="mt-0.5 shrink-0 text-sm text-gray-500"></fa-icon>
      <span class="text-xs text-gray-700">
        Jede Kopie zählt zu den myCheck-Vorlagen dieses Projekts. Kontextdateien des anderen Projekts
        werden nicht mitkopiert.
      </span>
    </div>
  </div>

  <div bicPopupButtonGroup class="flex w-full flex-row items-center justify-end gap-4">
    <bic-button (onClick)="onClose()" [disabled]="saving" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="onConfirm()" [loading]="saving">
      {{ selected.size > 0 ? 'Mit myChecks duplizieren' : 'Nur Prüflauf duplizieren' }}
    </bic-button>
  </div>
</bic-popup>
